const normalizeText = (value = '') => String(value || '').trim();

const toDate = (value = null) => {
  const date = value?.toDate?.() || (value ? new Date(value) : null);
  return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
};

const formatDateKey = (date = null) => (
  date
    ? [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-')
    : ''
);

const formatMomentDate = (dateKey = '') => {
  const date = toDate(`${dateKey}T12:00:00`);
  return date
    ? date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
    : '';
};

export const buildHistoricalSourceReceipt = (storyItem = {}) => {
  const scenes = Array.isArray(storyItem.sourceStoryScenes) ? storyItem.sourceStoryScenes : [];
  const captureDateKey = formatDateKey(toDate(
    storyItem.loggedAt || storyItem.createdAt || storyItem.timestamp
  ));
  const occurredDateKeys = [...new Set(scenes.map((scene) => normalizeText(
    scene.occurredOnDate || scene.metadata?.timelinePlanner?.occurredOnDate || ''
  )))];

  if (!scenes.length || !captureDateKey || occurredDateKeys.some((dateKey) => !dateKey || dateKey === captureDateKey)) {
    return null;
  }

  const countLabel = `${scenes.length} ${scenes.length === 1 ? 'moment' : 'moments'} added`;
  const dateLabel = occurredDateKeys.length === 1
    ? formatMomentDate(occurredDateKeys[0])
    : `${occurredDateKeys.length} earlier dates`;

  return {
    summary: [countLabel, dateLabel ? `to ${dateLabel}` : 'to earlier dates'].join(' '),
  };
};
